export const Footer = () => {
    return (
        <footer className="footer">
            Copyright © 2022. Biuro Rachunkowo-Ubezpieczeniowe Andrzej Dziurman.
        </footer>
    );
};